<template>
    <el-tooltip content="斜体" effect="dark" placement="top">
        <section class="upword-wrap" @click="onClick">
            <input type="file" id="upword-input" style="display: none;">
            <svg-icon icon-class="italics" class="upword" />
        </section>
    </el-tooltip>
</template>
  
<script>
export default {
    methods: {
        onClick(e) {
            this.$emit("click");
        }
    },
};
</script>
<style scoped lang="scss">
.upword-wrap {
    width: 40px;
    margin: 2px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    cursor: pointer;
    transition: all .2s ease-in-out;

    &:hover {
        background-color: #e4e9f2;
    }

    .upword {
        width: 20px;
        height: 20px;
    }
}
</style>